import { render, staticRenderFns } from "./editGame.vue?vue&type=template&id=05f6add6&scoped=true&"
import script from "./editGame.vue?vue&type=script&lang=js&"
export * from "./editGame.vue?vue&type=script&lang=js&"
import style0 from "./editGame.vue?vue&type=style&index=0&id=05f6add6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f6add6",
  null
  
)

export default component.exports